export const categories = [
  {
    slug: 'aiqing',
    name: '爱情',
    description: '浪漫动人的爱情故事，感受心动瞬间与真挚情感',
    icon: 'ri-heart-line',
    movieCount: 12,
  },
  {
    slug: 'xiju',
    name: '喜剧',
    description: '爆笑欢乐的喜剧佳作，让笑声驱散所有烦恼',
    icon: 'ri-emotion-laugh-line',
    movieCount: 15,
  },
  {
    slug: 'dongzuo',
    name: '动作',
    description: '热血沸腾的动作大片，震撼视觉与肾上腺素飙升',
    icon: 'ri-flashlight-line',
    movieCount: 18,
  },
  {
    slug: 'xuanyi',
    name: '悬疑',
    description: '扣人心弦的悬疑推理，烧脑剧情挑战你的智慧',
    icon: 'ri-search-eye-line',
    movieCount: 10,
  },
  {
    slug: 'kehuan',
    name: '科幻',
    description: '未来世界的科幻畅想，探索未知的宇宙奥秘',
    icon: 'ri-rocket-line',
    movieCount: 8,
  },
  {
    slug: 'donghua',
    name: '动画',
    description: '精彩纷呈的动画世界，适合全家一起观赏',
    icon: 'ri-movie-line',
    movieCount: 14,
  },
  {
    slug: 'kongbu',
    name: '恐怖',
    description: '惊悚刺激的恐怖体验，挑战你的心理极限',
    icon: 'ri-ghost-line',
    movieCount: 6,
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    description: '真实世界的纪录影像，拓宽视野的知识之旅',
    icon: 'ri-camera-line',
    movieCount: 9,
  },
];